import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import classNames from 'classnames';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PersonIcon from '@material-ui/icons/Person';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Grid } from '@material-ui/core';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import TextField from '@material-ui/core/TextField/index';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Loading from '../../../../../utils/Loading'
import {templateDelete} from '../../../../../services/Templates'
import Variable from '../../../../../helpers/Template/Variable'
import moment from 'moment'
import 'moment/locale/es'  
import { Button } from '@material-ui/core';
// Component styles
import styles from './styles';
import { ContactSupportOutlined } from '@material-ui/icons';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class DeleteTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success:false,
      isLoad:false,
      id:this.props.row[1].id,
      name:this.props.row[1].nombre,
    }
  }

  handleDelete=(e, value)=>{
    if(e.currentTarget.value==="1"){
      setTimeout(() => {this.props.handleTemplate()},100)  
    }else{
      const{id}=this.state
      var user=sessionStorage.getItem("user")
      var token=sessionStorage.getItem("key")
      templateDelete(user, token, id).then( value =>{
        if(value==="success"){
          setTimeout(() => {this.props.handleTemplate()},500)
        }
      })
    }
    
  }
  
  render() {
    const { classes, t } = this.props;
    const { isLoad, name}=this.state
    return (
      <PortletContent className={classes.content}>
        <Grid
          container
          spacing={2}
          className={classes.sizeTemplate}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            xl={12}
            style={{marginBottom:"20px"}}
          >
            <Typography  variant="body">{t('templateManager.deleteConfirm.message', { name })}</Typography>
          </Grid>
          <Grid
            item
            xs={5}
            sm={5}
            md={5}
            xl={5}
            style={{display:"flex", justifyContent: "center"}}
          >
            <Button value="0" onClick={this.handleDelete.bind(0)} color="primary">
              {t('templateManager.button.accept')}
            </Button>
          </Grid>
          <Grid
            item
            xs={2}
            sm={2}
            md={2}
            xl={2}
          >
          </Grid>
          <Grid
            item
            xs={5}
            sm={5}
            md={5}
            xl={5}
            style={{display:"flex", justifyContent: "center"}}
          >
            <Button value="1" onClick={this.handleDelete.bind(1)} color="primary">
              {t('templateManager.button.cancel')}
            </Button>
          </Grid>
          
        </Grid>
        
      </PortletContent>
    )
  }
}

export default compose(withStyles(styles), withTranslation())(DeleteTemplate);
